<div class="alinhamento-tela">
    <app-titulo [titulo]="'Meu Perfil'"></app-titulo>
  <section class="perfil-container">
    <div class="perfil-content">
      <div class="perfil-header">
        <div class="avatar-container">
          <img src="../../../assets/icone/qlementine-icons_user-16.svg" alt="Avatar">
        </div>
        <div class="usuario-info">
          <span class="usuario-nome">{{usuario.nome}}</span>
          <div class="usuario-email">
            <img src="../../../assets/icone/material-symbols_mail.svg" alt="Email" class="email-icon">
            <span>{{usuario.email}}</span>
          </div>
        </div>
      </div>
      @if(!mostrarCamposSenha) {
        <app-button class="btn-alterar-senha" (click)="toggleAlterarSenha()" texto="Alterar Senha"></app-button>
      }

      @if(mostrarCamposSenha) {
        <div class="campos-senha">
          <app-form-field
            classe="senha-perfil"
            placeholder="Digite a senha atual"
            [value]="novaSenha.senhaAtual"
            (onChangeValue)="novaSenha.senhaAtual = $event">
          </app-form-field>
          <app-form-field
            classe="senha-perfil"
            placeholder="Digite a nova senha"
            [value]="novaSenha.novaSenha"
            (onChangeValue)="novaSenha.novaSenha = $event">
          </app-form-field>
          <app-form-field
            classe="senha-perfil"
            placeholder="Confirme a nova senha"
            [value]="novaSenha.confirmarSenha"
            (onChangeValue)="novaSenha.confirmarSenha = $event">
          </app-form-field>
          <div class="botoes-senha">
            <app-button
              class="btn-confirmar-senha"
              (click)="abrirDialogConfirmacao()"
              texto="Alterar Senha">
            </app-button>
            <app-button
              class="btn-cancelar-senha"
              (click)="cancelarAlteracaoSenha()"
              texto="Cancelar">
            </app-button>
          </div>
        </div>
      }

      <app-button
        class="btn-sair"
        variant="outline"
        (click)="sair()"
        texto="Sair do Sistema">
      </app-button>
    </div>
  </section>
</div>
